import { Component, Input, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'calsoft-nested-side-menu-child',
  templateUrl: './nested-side-menu-child.component.html',
  styleUrls: ['./nested-side-menu-child.component.scss']
})
export class NestedSideMenuChildComponent implements OnInit {
  @Input() child: any;
  @Input() categoryList:any;
  @Input() index:any;
  constructor(
    private commonService:CommonService

  ) { }

  ngOnInit(): void {

  }

  productList(menu,length){
    if(length ==0){
      this.commonService.selectedCategory(menu.categoryName,menu.categoryId,menu);
     // this.commonService.goToCategory(item.categoryName,Constant.DEFAULT_PAGE_SIZE);

    }else{

    }

  }
  toggleItem(j) {

    let i=this.index
    if(this.categoryList[i].subcategories[j].subcategories.length >0){
      this.categoryList[i].subcategories[j].open = !this.categoryList[i].subcategories[j].open;
    }
  }


  public toggleMenuItem(menuId) {
    let menuItem = document.getElementById('menu-item-' + menuId);
    let subMenu = document.getElementById('sub-menu-' + menuId);
    if (subMenu) {
      if (subMenu.classList.contains('show')) {
        subMenu.classList.remove('show');
        menuItem.classList.remove('expanded');
      }
      else {
        subMenu.classList.add('show');
        menuItem.classList.add('expanded');
      }
    }
  }


}
